import config from "@/config";
import http from "@/utils/request";

// 权限管理：菜单节点（迁移自 newsaas menus.js，裁剪多租户双轨，URL 统一小写）
export default {
	nodeIndex: {
		url: `${config.API_URL}/manage/node/index`,
		name: "获取菜单节点",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},
	nodeDelete: {
		url: `${config.API_URL}/manage/node/delete`,
		name: "删除节点",
		post: async function (data = {}) {
			return await http.post(this.url, data);
		},
	},
	nodeAdd: {
		url: `${config.API_URL}/manage/node/add`,
		name: "添加节点",
		post: async function (data = {}) {
			return await http.post(this.url, data);
		},
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},
	nodeEdit: {
		url: `${config.API_URL}/manage/node/edit`,
		name: "编辑节点",
		post: async function (data = {}) {
			return await http.post(this.url, data);
		},
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},
	getNodeTree: {
		url: `${config.API_URL}/manage/node/getNodeTree`,
		name: "菜单节点上级列表",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},
	setStatus: {
		url: `${config.API_URL}/manage/node/setStatus`,
		name: "节点是否启用",
		post: async function (data = {}) {
			return await http.post(this.url, data);
		},
	},
	setShow: {
		url: `${config.API_URL}/manage/node/setShow`,
		name: "节点是否菜单",
		post: async function (data = {}) {
			return await http.post(this.url, data);
		},
	},
};
